import slMessages from '../locales/sl_SI';

const SlLang = {
  messages: {
    ...slMessages,
  },
  locale: 'sl-SI',
};
export default SlLang;
